<div class="fullscreen-dialog">
  <div class="dialog-header">
    <app-dialog-header
      titleTranslateKey="scheduler.diary.resource-editor.title"
      [showAuditButton]="true"
      [auditDisabled]="!loaded"
      (closeClicked)="onCancelClick()"
      (auditClicked)="openAudit()"
    >
    </app-dialog-header>
    <ngx-ui-loader [loaderId]="'zoneEditLoader'"></ngx-ui-loader>
  </div>

  <mat-dialog-content>
    @if (loaded) {
      <div class="content-container">
        <div class="main-content">
          <form [formGroup]="resourceAvailabilityForm">
            <mat-form-field appearance="fill" class="note-field">
              <mat-label>Note</mat-label>
              <input
                formControlName="description"
                matInput
                placeholder="Enter note"
                aria-label="Note"
              />
            </mat-form-field>
            <div class="form-main">
              <div class="form-wrapper">
                <mat-form-field appearance="fill">
                  <mat-label>Date</mat-label>
                  <input
                    [matDatepicker]="picker"
                    formControlName="start"
                    matInput
                    aria-label="Select date"
                  />
                  <mat-datepicker-toggle
                    [for]="picker"
                    matSuffix
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
                <div>
                  <mat-form-field
                    appearance="fill"
                    style="width: 113px; height: 80px !important"
                  >
                    <mat-label>Start</mat-label>
                    <input
                      (change)="startTimeChanged($event)"
                      formControlName="startTime"
                      matInput
                      type="time"
                      aria-label="Start time"
                    />
                  </mat-form-field>
                  <mat-form-field
                    appearance="fill"
                    style="
                      width: 113px;
                      margin-left: 18px;
                      height: 80px !important;
                    "
                  >
                    <mat-label>End</mat-label>
                    <input
                      formControlName="endTime"
                      matInput
                      type="time"
                      aria-label="End time"
                    />
                  </mat-form-field>
                </div>
                <div class="code-selector-row">
                  <mat-form-field appearance="fill">
                    <mat-label>Code (optional)</mat-label>
                    <mat-select
                      (selectionChange)="selectedCodeChange($event)"
                      formControlName="availabilityCode"
                      aria-label="Select code"
                    >
                      <mat-option>None</mat-option>
                      @for (code of availabilityCodes; track code) {
                        <mat-option [value]="code">
                          <div class="code-option">
                            <div
                              class="{{
                                testIsBlockType(code.availabilityType)
                                  ? 'unavailability-circle'
                                  : 'availability-circle'
                              }}"
                            ></div>
                            {{ code.description }}
                          </div>
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  @if (isBlockType) {
                    <div class="unavailability-circle"></div>
                  }
                  @if (!isBlockType) {
                    <div class="availability-circle"></div>
                  }
                </div>
              </div>
              <div class="form-wrapper">
                <span class="slider-label">Cyclical Reservation</span>
                <mat-slider
                  class="reservation-slider"
                  [min]="0"
                  [max]="100"
                  [step]="1"
                  [discrete]="true"
                  [displayWith]="formatLabel"
                  [disabled]="!allowPriorityReservation"
                >
                  <input
                    matSliderThumb
                    [value]="cyclicalPriorityReservationPercent"
                    (valueChange)="onSliderChange('cyclical', $event)"
                    aria-label="Cyclical reservation percentage"
                  />
                </mat-slider>
                <span class="slider-label">Normal Reservation</span>
                <mat-slider
                  class="reservation-slider"
                  [min]="0"
                  [max]="100"
                  [step]="1"
                  [discrete]="true"
                  [displayWith]="formatLabel"
                  [disabled]="!allowPriorityReservation"
                >
                  <input
                    matSliderThumb
                    [value]="normalPriorityReservationPercent"
                    (valueChange)="onSliderChange('normal', $event)"
                    aria-label="Normal reservation percentage"
                  />
                </mat-slider>
                <span class="slider-label">High Reservation</span>
                <mat-slider
                  class="reservation-slider"
                  [min]="0"
                  [max]="100"
                  [step]="1"
                  [discrete]="true"
                  [displayWith]="formatLabel"
                  [disabled]="!allowPriorityReservation"
                >
                  <input
                    matSliderThumb
                    [value]="highPriorityReservationPercent"
                    (valueChange)="onSliderChange('high', $event)"
                    aria-label="High reservation percentage"
                  />
                </mat-slider>
                <span class="slider-label">Emergency Reservation</span>
                <mat-slider
                  class="reservation-slider"
                  [min]="0"
                  [max]="100"
                  [step]="1"
                  [discrete]="true"
                  [displayWith]="formatLabel"
                  [disabled]="!allowPriorityReservation"
                >
                  <input
                    matSliderThumb
                    [value]="emergencyPriorityReservationPercent"
                    (valueChange)="onSliderChange('emergency', $event)"
                    aria-label="Emergency reservation percentage"
                  />
                </mat-slider>
              </div>
            </div>
            @if (timesheetCodeMode) {
              <div style="margin: 0">
                <div class="row-display">
                  @if (selectedTravelCodeLoaded) {
                    <app-timesheet-code-chooser
                      (codeChanged)="handleTravelCodeChange($event)"
                      [selectedCode]="selectedTravelCode"
                      [timesheetCodes]="timesheetCodes"
                      displayAs="Travel"
                    />
                  }
                  @if (selectedWorkCodeLoaded) {
                    <app-timesheet-code-chooser
                      (codeChanged)="handleWorkCodeChange($event)"
                      [selectedCode]="selectedWorkCode"
                      [timesheetCodes]="timesheetCodes"
                      displayAs="Work"
                    />
                  }
                  <mat-form-field
                    appearance="fill"
                    style="width: 113px; height: 80px !important"
                  >
                    <mat-label>Overtime From</mat-label>
                    <input
                      (change)="overTimeChanged($event)"
                      formControlName="overTime"
                      matInput
                      type="time"
                      aria-label="Overtime from"
                    />
                  </mat-form-field>
                  @if (selectedOverCodeLoaded) {
                    <app-timesheet-code-chooser
                      (codeChanged)="handleOverCodeChange($event)"
                      [selectedCode]="selectedOverCode"
                      [timesheetCodes]="timesheetCodes"
                      displayAs="Over"
                    />
                  }
                </div>
              </div>
            }
          </form>
        </div>

        <!-- Effective Skills and Zones Column -->
        <div class="skills-zones-column">
          <div class="effective-data-section">
            <h3>Effective Skills and Zones</h3>
            @if (resource) {
              <div class="resource-name">
                <strong>Resource:</strong> {{ resource.name || resource.id }}
              </div>
            }

            @if (effectiveDataLoading) {
              <div class="loading-message">
                <mat-spinner diameter="24"></mat-spinner>
                <span>Loading effective skills and zones...</span>
              </div>
            } @else if (effectiveDataError) {
              <div class="error-message">
                <mat-icon color="warn">error</mat-icon>
                <span>{{ effectiveDataError }}</span>
              </div>
            } @else if (effectiveDataLoaded) {
              @if (effectiveSkills.length > 0) {
                <div class="effective-list">
                  <h4>Skills</h4>
                  <ul>
                    @for (skill of effectiveSkills; track skill.id) {
                      <li>
                        {{
                          skill.description ||
                            skill.name ||
                            "Skill ID: " + skill.id
                        }}
                      </li>
                    }
                  </ul>
                </div>
              }

              @if (effectiveZones.length > 0) {
                <div class="effective-list">
                  <h4>Zones</h4>
                  <ul>
                    @for (zone of effectiveZones; track zone.id) {
                      <li>
                        {{
                          zone.description || zone.name || "Zone ID: " + zone.id
                        }}
                      </li>
                    }
                  </ul>
                </div>
              }

              @if (
                effectiveSkills.length === 0 && effectiveZones.length === 0
              ) {
                <div class="no-data-message">
                  No effective skills or zones found for this availability.
                </div>
              }
            }
          </div>
        </div>
      </div>
    }
  </mat-dialog-content>
</div>
@if (canEdit) {
  <mat-dialog-actions>
    <button (click)="onDeleteClick()" color="warn" mat-flat-button>
      {{ "scheduler.general.delete" | translate }}
    </button>
    <!-- <button (click)="resetForm()" mat-flat-button type="reset">{{ 'scheduler.general.undo' | translate }}</button> -->
    <button
      (click)="save()"
      [disabled]="resourceAvailabilityForm.pristine"
      color="primary"
      mat-raised-button
      type="submit"
    >
      Save
    </button>
  </mat-dialog-actions>
}
